<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Activated Task List</li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Activated Task List</strong>
    </span>
    <span style="float: right">
      <button type="button" class="btn btn-sm btn-primary" (click)="CreateTask()" [appHasPermission]="[
      { Url: '/tasks/activatedAll/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskAll' },
      { Url: '/tasks/activatedIndividual/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskIndividual' }
      ]">
        <i class="fa fa-plus"></i>Create Task
      </button> &nbsp; &nbsp; &nbsp;

      <button type="button" class="btn btn-sm btn-primary" [appHasPermission]="[
        { Url: '/tasks/activatedAll/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskAll' },
        { Url: '/tasks/activatedIndividual/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskIndividual' }
      ]" data-toggle="modal" data-target="#configureSettingsDialog" (click)="getPeriodicTaskConfiguration()">
        <i class="fa fa-plus"></i> Configure Settings
      </button> &nbsp; &nbsp; &nbsp;

      <button type="button" class="btn btn-sm btn-primary pull-right" (click)="EditReminderFrequency()"
        [appHasPermission]="[
        { Url: '/tasks/activatedAll/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskAll' },
        { Url: '/tasks/activatedIndividual/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskIndividual' }
      ]">
        <i class="fa fa-pencil"></i> Edit Reminder Frequency
      </button>
    </span>
  </div>

  <section class="card search-box">
      <div class="card-header" (click)="toggleSearchCollapse()" style="cursor: pointer;">
        Modify Search 
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
    
    <div class="card-block" *ngIf="!isSearchCollapsed">
      <!-- Row 1: Labels for Dropdowns -->
      <div class="row filter-row-labels">
        <div class="col-md-4">
          <label>Tag</label>
        </div>
        <div class="col-md-4">
          <label>Trigger ID</label>
        </div>
        <div class="col-md-4">
          <label>Task Status</label>
        </div>
      </div>

      <!-- Row 2: All Dropdowns -->
      <div class="row filter-row-dropdowns">
        <div class="col-md-4">
          <div class="form-group">
            <select id="groupdropdown" [(ngModel)]="groupname" class="form-control select"
              (change)="getSelectedGroupID($event)">
              <option [value]=null>Select</option>
              <option *ngFor="let group of groupTypes" value={{group._id}}>
                {{group.GroupName}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <select id="triggerIddropdown" [(ngModel)]="triggerId" class="form-control select">
              <option [value]=null>Select</option>
              <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                {{taskTriggerType.Name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <select id="taskStatusdropdown" [(ngModel)]="selcettaskname" class="form-control select"
              (change)="getSelectedTaskStatus($event)">
              <option *ngIf="selcettaskname==null" [value]=null>Select</option>
              <option *ngFor="let taskStatus of taskStatusTypes" value={{taskStatus.id}}>
                {{taskStatus.name}}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Row 3: Labels for Radio Options -->
      <div class="row filter-row-labels">
        <div class="col-md-4">
          <label>User defined / Predefined</label>
        </div>
        <div class="col-md-4">
          <label>Event Based / Periodic</label>
        </div>
        <div class="col-md-4">
          <label>Emails</label>
        </div>
      </div>

      <!-- Row 4: All Radio Button Options -->
      <div class="row filter-row-options">
        <div class="col-md-4">
          <div class="radio-options-group">
            <div class="md-radio md-radio-inline">
              <input id="IsPredefinedYes" type="radio" name="TaskuserdefinedorPredefined"
                [(ngModel)]="SearchtaskUserdefinedorPredefinedModel" value='true' class="form-check-input">
              <label for="IsPredefinedYes">Predefined</label>
            </div>
            <div class="md-radio md-radio-inline">
              <input id="IsPredefinedNo" type="radio" name="TaskuserdefinedorPredefined"
                [(ngModel)]="SearchtaskUserdefinedorPredefinedModel" value='false' class="form-check-input">
              <label for="IsPredefinedNo">User defined</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="radio-options-group">
            <div class="md-radio md-radio-inline">
              <input id="IsEventBased" type="radio" name="TaskEventbasedorPeriodic"
                [(ngModel)]="SearchtaskEventbasedorPeriodicModel" value='1' class="form-check-input"
                (click)="CheckTriggerType('Event')">
              <label for="IsEventBased">Event Based</label>
            </div>
            <div class="md-radio md-radio-inline">
              <input id="IsPeriodic" type="radio" name="TaskEventbasedorPeriodic"
                [(ngModel)]="SearchtaskEventbasedorPeriodicModel" value='2' class="form-check-input"
                (click)="CheckTriggerType('Periodic')">
              <label for="IsPeriodic">Periodic</label>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="radio-options-group">
            <div class="md-radio md-radio-inline">
              <input id="IsEmailSendYes" type="radio" name="IsEmailSend"
                [(ngModel)]="IsEmailSend" [value]='true' class="form-check-input">
              <label for="IsEmailSendYes">ON</label>
            </div>
            <div class="md-radio md-radio-inline">
              <input id="IsEmailSendNo" type="radio" name="IsEmailSend"
                [(ngModel)]="IsEmailSend" [value]='false' class="form-check-input">
              <label for="IsEmailSendNo">OFF</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 5: Date Pickers and Action Buttons -->
      <div class="row filter-row-dates">
        <div class="col-md-3">
          <label>From (Due Date)</label>
        </div>
        <div class="col-md-3">
          <label>To (Due Date)</label>
        </div>
        <div class="col-md-6">
          <!-- Empty space for alignment -->
        </div>
      </div>
      <div class="row filter-row-dates-inputs">
        <div class="col-md-3">
          <div class="form-group">
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [(ngModel)]="activatedTaskSearchDateFrom" style="padding:6px;z-index: 0;"
                placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker" (focus)="c.toggle();r.close();"
                (document:click)="c.close();" (ngModelChange)="activatedTaskSearchFromDuedateChange()"
                [ngModelOptions]="{standalone: true}">
              <button class="input-group-addon" (click)="c.toggle();r.close();" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <div class="input-group" (click)="$event.stopPropagation()">
              <input class="form-control" [(ngModel)]="activatedTaskSearchDateTo" style="padding:6px;z-index: 0;"
                placeholder="dd-mm-yyyy" ngbDatepicker #r="ngbDatepicker" (focus)="r.toggle();c.close();"
                (document:click)="r.close();" [ngModelOptions]="{standalone: true}" [minDate]="minDateForSearchTo">
              <button class="input-group-addon" (click)="r.toggle();c.close();" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="filter-actions">
            <button type="button" [disabled]="response" (click)="showTasksBySearchData()"
              class="btn btn-sm btn-primary" title="search">
              <i class="fa fa-search"></i>Search
            </button>
            <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear" (click)="showAllTasks()"
              title="refresh">
              <i class="fa fa-refresh"></i>Clear
            </button>
          </div>
        </div>
      </div>


    </div>
  </section>


  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="datatabletool input-group">


          <button type="button" class="btn btn-sm btn-primary" [disabled]="!IsSelectedTasks"
            (click)="showStatusandUploadProofDialog()"  data-target="#uploadProofDialog"
            [appHasPermission]="[{'Url': '/tasks/activatedAll/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskAll'},
            {'Url': '/tasks/activatedIndividual/edit?goveva=true&email=', 'method':'put', 'menu': 'ActivatedTaskIndividual'}]">
            <i class="fa fa-save"></i>Task completion
          </button>
          &nbsp;&nbsp;


          <button (click)="showaddTasktoProcessDialog()" type="button" 
            data-target="#addtasktoprocessDialog" class="btn btn-sm btn-primary"
            [disabled]="!(selectedProcessCount == 0 && selectedEventBaseCount > 0) ||!IsSelectedTasks ">
            <i class="fa fa-save"></i>Add to Process</button>
          &nbsp;&nbsp;
          <button type="button" class="btn btn-sm btn-primary" [disabled]="!IsSelectedTasks"
            (click)="showSendImmediateReminderMailDialog()" [appHasPermission]="[
            { Url: '/tasks/activatedAll/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskAll' },
            { Url: '/tasks/activatedIndividual/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskIndividual' }
          ]">
            <i class="fa fa-save"></i> Send Immediate Mail
          </button>
          &nbsp;&nbsp;

          <button type="button" class="btn btn-sm btn-primary"
            [disabled]="!IsSelectedTasks || !onlySenEmailTaskButtonEnable" (click)="showEmailStatusDialog()"
             data-target="#sendEmailToSelectedTask" [appHasPermission]="[
            { Url: '/tasks/activatedAll/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskAll' },
            { Url: '/tasks/activatedIndividual/edit?goveva=true&email=', method: 'put', menu: 'ActivatedTaskIndividual' }
          ]">
            <i class="fa fa-save"></i> Email Status
          </button>

        </div>
        <div class="margin-bottom-50">
          <div class="table-responsive" style="position: relative;">
            <!-- Loader overlay for Activated Tasks -->
            <div class="activated-task-loader-overlay" *ngIf="isLoading">
              <div class="activated-task-loader-container">
                <img src="assets/images/DigiCompany_loader.png" class="activated-task-spinner" alt="Loading..." />
              </div>
            </div>
            <table #activatedcompanytaskTable
            datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" id="activatedcompanytaskTable"
              style="cursor: pointer;">

              <thead>
                <tr>
                  <th style="display:none"></th>
                  <th>
                    <div class="md-checkbox">
                      <input id="selectcheckboxall" class="md-checkbox" type="checkbox" [(ngModel)]="selectedAll"
                        (change)="selectAll();" [disabled]="!hasPermission" />
                      <label for="selectcheckboxall">&nbsp;</label>
                    </div>
                  </th>
                  <th class="activatedTask-list-column">Task Name </th>
                  <th class="activatedTask-list-column">Task Particulars</th>
                  <th class="activatedTask-list-column">Tag</th>
                  <th class="activatedTask-list-column">Assigned To</th>
                  <th>Due Date</th>
                  <th style="display: none">Due Date</th>
                  <th>Completed Date</th>
                  <th style="display: none">Completed Date</th>
                  <th>Task Status </th>
                  <th class="activated-list-action">Action</th>
                  <th style="display: none">Statutory/Internal </th>
                  <th style="display: none">Risk Profile </th>
                  <th style="display: none">Meeting Type </th>
                  <th style="display: none">Trigger Type </th>
                  <th style="display: none">Trigger Id </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let companytask of companytasklist; let count=index"
                  [ngClass]="{'inActiveCompanyTasks':companytask.TriggerID?.Name == 'Fixed Date' && companytask.DueDate==null}">
                  <td tabindex="1" style="display: none">{{companytask._id}}</td>
                  <td>
                    <div class="md-checkbox">
                      <input id="selectcheckbox{{count +1 }}" type="checkbox" [(ngModel)]="companytask.SelectedTask"
                        (change)="checkIfAllSelected($event,companytask.TriggerType, companytask.TaskStatus);"
                        (change)="checkselected($event);" [disabled]="!hasPermission">
                      <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                    </div>
                  </td>
                  <td class="activatedTask-list-column">{{companytask.TaskName }} </td>
                  <td class="activatedTask-list-column">
                    <span
                      *ngIf="companytask.ActivatedTaskParticularId!= undefined && companytask.ActivatedTaskParticularId!= null; else noTaskParticulars">{{companytask.ActivatedTaskParticularId.TaskParticulars
                      }}</span>
                    <ng-template #noTaskParticulars>-</ng-template>
                  </td>
                  <td class="activatedTask-list-column">{{companytask.GroupID?.GroupName }} </td>
                  <td class="activatedTask-list-column">{{companytask.AssignedUserName}} </td>
                  <td>
                    <span *ngIf="companytask.DueDate && companytask.DueDate!=null;else notdueDate">
                      <span style="display: none">{{companytask.DueDate | date : "yMMdd"}}
                      </span>{{companytask.DueDate | date : "dd-MM-y" }}</span>
                    <span #notdueDate
                      *ngIf="companytask.TriggerID?.Name != 'Fixed Date';else fixedTriggerDueDate">-</span>
                    <span #fixedTriggerDueDate
                      *ngIf="companytask.TriggerID?.Name == 'Fixed Date' && companytask.DueDate==null">Please select
                      specific date</span>

                  </td>
                  <td style="display: none">
                    <span *ngIf="companytask.DueDate && companytask.DueDate!=null;else notdueDate2">
                      {{companytask.DueDate | date : "dd-MM-y" }}</span>
                    <span #notdueDate2
                      *ngIf="companytask.TriggerID?.Name != 'Fixed Date';else fixedTriggerDueDate2">-</span>
                    <span #fixedTriggerDueDate2 *ngIf="companytask.TriggerID?.Name == 'Fixed Date'">Please select
                      specific date</span>
                  </td>

                  <td>
                    <span *ngIf="companytask.CompletedDate && companytask.CompletedDate!=null;else notcompDate">
                      <span style="display: none">{{companytask.CompletedDate | date :
                        "yMMdd"}}</span>{{companytask.CompletedDate | date : "dd-MM-y"
                      }}
                    </span>
                    <ng-template #notcompDate>-</ng-template>
                  </td>
                  <td style="display: none">
                    <span *ngIf="companytask.CompletedDate && companytask.CompletedDate!=null;else notcompDate2">
                      {{companytask.CompletedDate | date : "dd-MM-y"
                      }}
                    </span>
                    <ng-template #notcompDate2>-</ng-template>
                  </td>
                  <td> {{getTaskStatus(companytask.DueDate,companytask.CompletedDate,companytask.TaskStatus)}}</td>
                  <td class="activated-list-action">
                    <button type="button" class="btn-sm btn btn-warning" (click)="EditTask(companytask._id)">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;&nbsp;
                  </td>
                  <td class="activatedTask-list-column" style="display: none">{{getPolicyType(companytask.PolicyType)}}
                  </td>
                  <td class="activatedTask-list-column" style="display: none">{{getRiskType(companytask.RiskType)}}</td>
                  <td class="activatedTask-list-column" style="display: none">
                    {{(companytask.MeetingTypeID)?companytask.MeetingTypeID.MeetingType:"-" }} </td>
                  <td class="activatedTask-list-column" style="display: none">
                    {{(companytask.TriggerType == 1)?'Event':'Periodic'}} </td>
                  <td class="activatedTask-list-column" style="display: none">
                    {{(companytask.TriggerID)?companytask.TriggerID.Name:'-'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="addtasktoprocessDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <form [formGroup]="activatedProcessTasksForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">process</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">

              <div class="col-md-6">
                <label class="form-control-label" for="l0"> (Pre defined / User defined)
                </label>
              </div>
              <div class="col-md-6">
                <div class="form-group">

                  <div class="md-radio md-radio-inline">
                    <input id="IsPreDefined" type="radio"
                      [formControl]="activatedProcessTasksForm.controls['IsPredefinedorUserdefined']"
                      style="position:absolute" name="IsPredefinedorUserdefined" value="Predefined"
                      (click)="CheckProcessType('Predefined')" class="form-check-input">
                    <label for="IsPreDefined">Pre defined</label>
                  </div>
                  <div class="md-radio md-radio-inline">
                    <input id="IsUserDefined" type="radio"
                      [formControl]="activatedProcessTasksForm.controls['IsPredefinedorUserdefined']"
                      style="position:absolute" name="IsPredefinedorUserdefined" value="Userdefined"
                      (click)="CheckProcessType('Userdefined')" class="form-check-input">
                    <label for="IsUserDefined">User defined</label>
                  </div>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Select Process
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <select [formControl]="activatedProcessTasksForm.controls['ProcessID']" class="form-control select">
                    <option value=""> Select </option>
                    <option *ngFor="let process of processes" value={{process._id}}>
                      {{process.ProcessName}}
                    </option>
                  </select>
                  <div
                    *ngIf="activatedProcessTasksForm.controls['ProcessID'].hasError('required') && activatedProcessTasksForm.controls['ProcessID'].touched"
                    class="form-control-error-custom">
                    Process is required.
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="modal-footer">

            <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary"
              [disabled]='!activatedProcessTasksForm.valid || disabledOnclick' (click)="addTaskstoActivatedProcess()">
              <i class="fa fa-save"></i>Save </button>

            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="uploadProofDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form [formGroup]="uploadProofactivatedTaskForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Upload Proof</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Task Status </label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <select [formControl]="uploadProofactivatedTaskForm.controls['TaskStatus']"
                    class="form-control select" [(ngModel)]="TaskStatusModel">
                    <option *ngFor="let taskStatus of taskStatusTypes" [disabled]="taskStatus.isDisabled"
                      value={{taskStatus.id}}>
                      {{taskStatus.name}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="(TaskStatusModel!= undefined && TaskStatusModel==2)">

              <div class="col-md-4">
                <label class="form-control-label" for="l0">Completed Date</label>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <div class="input-group" (click)="$event.stopPropagation()">
                    <input class="form-control" [formControl]="uploadProofactivatedTaskForm.controls['CompletedDate']"
                      [(ngModel)]="CompletedDateModel" style="padding:6px;" placeholder="dd-mm-yyyy"
                      name="dtCompletedDate" ngbDatepicker #c="ngbDatepicker" [maxDate]="todaysDate"
                      (click)="c.toggle();" (document:click)="c.close();">

                    <button class="input-group-addon" (click)="c.toggle();" type="button">
                      <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                    </button>
                  </div>

                  <div *ngIf="(TaskStatusModel==='2' && (CompletedDateModel===undefined || CompletedDateModel===null))"
                    class="form-control-error-custom">
                    Please Select Date.
                  </div>
                </div>
              </div>

            </div>

          </div>
          <div class="modal-footer">
            <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary" *ngIf="count == 1"
              (click)="initiateUploadProof()">
              <i class="fa fa-save"></i>Upload Proof</button>
            <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary"
              [disabled]="(TaskStatusModel==='2' && (CompletedDateModel===undefined || CompletedDateModel===null) || disabledOnclick || !fileExtension )"
              (click)="uploadProofDocument()">
              <i class="fa fa-save"></i>Update Status</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal fade modal-size-medium" id="sendEmailToSelectedTask" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Change Email Status</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <label class="form-control-label" for="l0">Email Status</label>
              </div>
              <div class="col-md-8">
                <div class="md-radio md-radio-inline">
                  <input id="IsEmailSendYesSelectedTask" type="radio" style="position:absolute"
                    name="IsEmailSendSelected" [(ngModel)]="IsEmailSendActivatedTask" [value]='true'
                    class="form-check-input">
                  <label for="IsEmailSendYesSelectedTask">ON</label>
                </div>
                <div class="md-radio md-radio-inline">
                  <input id="IsEmailSendNoPeriodic" type="radio" style="position:absolute" name=" IsEmailSendSelected"
                    [(ngModel)]="IsEmailSendActivatedTask" [value]='false' class="form-check-input">
                  <label for="IsEmailSendNoPeriodic">OFF</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary"
              [disabled]="(TaskStatusModel==='2' && (CompletedDateModel===undefined || CompletedDateModel===null) || disabledOnclick)"
              (click)="updateSendEmailCondition()">
              <i class="fa fa-save"></i>Update</button>
            <button type="button" class="btn btn-sm" data-dismiss="modal">
              <i class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade modal-size-medium" id="configureSettingsDialog" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <form [formGroup]="taskConfigurationForm" class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Configuration</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="row">
              <div class="col-md-6">
                <label class="form-control-label" for="l0">Select Default Assigned User
                  <span _ngcontent-c2="" style="color: red;">*</span>
                </label>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <select [formControl]="taskConfigurationForm.controls['UserId']" class="form-control select"
                    (change)="selectedUserChange()">
                    <option value=""> Select </option>
                    <option *ngFor="let user of assignedusers" value={{user._id}}>
                      {{user.FirstName + " "+ user.LastName}}
                    </option>
                  </select>
                  <div
                    *ngIf="taskConfigurationForm.controls['UserId'].hasError('required') && taskConfigurationForm.controls['UserId'].touched"
                    class="form-control-error-custom">
                    User is required.
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="modal-footer">

            <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary"
              [disabled]='!taskConfigurationForm.valid || disabledOnclick' (click)="addPeriodicTaskConfiguration()"><i
                class="fa fa-save"></i>Save </button>

            <button type="button" class="btn btn-sm" data-dismiss="modal"> <i class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>


  <div class="modal fade modal-size-large" id="taskCronConfiguration" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true">
    <div class="modal-dialog">
      <form class="well">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Cron Configuration</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" *ngFor="let conf of cronConfigurations; let i = index;">
            <div>
              <div class="row">
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label" for="l0">Cron Name
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <input id="cronName" type="text" name="cronConfigurations[i].cronName"
                          [(ngModel)]="cronConfigurations[i].cronName" class="form-control">

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label" for="l0">Select Cron Frequency
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <select name="cronConfigurations[i].cronFrequency"
                          [(ngModel)]="cronConfigurations[i].cronFrequency" class="form-control select">
                          <option value=""> Select </option>
                          <option *ngFor="let feq of cronFrequencyData" [value]="feq">
                            {{feq}}
                          </option>
                        </select>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3"
                  *ngIf="cronConfigurations[i].cronFrequency == 'Weekly' || cronConfigurations[i].cronFrequency == 'Every 2 weeks'">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label" for="l0">Select Day
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <select name="cronConfigurations[i].weeklyDay" [(ngModel)]="cronConfigurations[i].weeklyDay"
                          class="form-control select">
                          <option value=""> Select </option>
                          <option value="0">Sunday</option>
                          <option value="1">Monday</option>
                          <option value="2">Tuesday</option>
                          <option value="3">Wednesday</option>
                          <option value="4">Thursday</option>
                          <option value="5">Friday</option>
                          <option value="6">Saturday</option>
                        </select>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3"
                  *ngIf="cronConfigurations[i].cronFrequency == 'Monthly' || cronConfigurations[i].cronFrequency == 'Every 2 months' || cronConfigurations[i].cronFrequency == 'Every 3 months'">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label" for="l0">Select Date
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <select name="cronConfigurations[i].cronDate" [(ngModel)]="cronConfigurations[i].cronDate"
                          class="form-control select">
                          <option value=""> Select </option>
                          <option *ngFor="let date of CronDates" value="{{date}}">{{date}}</option>
                        </select>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label" for="l0">No. of Days
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <input id="noOfDays" type="text" name="cronConfigurations[i].noOfDays"
                          [(ngModel)]="cronConfigurations[i].noOfDays" class="form-control">

                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-4">
                      <label class="form-control-label" for="l0">Email To
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <textarea id="emailTo" type="text" name="cronConfigurations[i].emailTo"
                          [(ngModel)]="cronConfigurations[i].emailTo" class="form-control"></textarea>

                      </div>
                    </div>
                  </div>
                </div>


                <div class="col-md-1" *ngIf="i == 0">
                  <button class="form-group" (click)="addNewRow()" type="button">
                    <em class="fa fa-plus"></em></button>
                </div>
                <div class="col-md-1" *ngIf="i >= 1">
                  <button type="button" class="form-group" (click)="removeField(i)">
                    <span class="icmn-bin"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">

            <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" *ngIf="addBtn"
              (click)="saveCronConfiguration()"><i class="fa fa-save"></i>Save </button>

            <button id="btnupdateTasktoProcess" type="button" class="btn btn-sm btn-primary" *ngIf="!addBtn"
              (click)="updateCronConfiguration()"><i class="fa fa-save"></i>Update </button>

            <button type="button" class="btn btn-sm" data-dismiss="modal"> <i class="fa fa-times"></i>Close</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
<app-alert></app-alert>
<div class="modal fade modal-size-medium" id="immediateReminder" tabindex="-1" role="dialog" aria-labelledby=""
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form class="well">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel">Send Immediate reminder mail</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div>
                <h5 class="font-weight-bold">To<span _ngcontent-c2="" style="color: red;">*</span></h5>
              </div>
              <div class="md-checkbox">
                <input id="ToAssignedTo" type="checkbox" name="ToAssignedTo" [(ngModel)]="ToAssignedTo"
                  [disabled]="AssignedTocc" (change)="sentIntimationFormValid($event)">
                <label for="ToAssignedTo">Assigned To </label>
              </div>
              <div class="md-checkbox">
                <input id="1Escalation" type="checkbox" name="OneEscalation" [(ngModel)]="OneEscalation"
                  [disabled]="OneEscalationcc" (change)="sentIntimationFormValid($event)">
                <label for="1Escalation">1st Escalation</label>
              </div>
              <div class="md-checkbox">
                <input id="2Escalation" type="checkbox" name="TwoEscalation" [(ngModel)]="TwoEscalation"
                  [disabled]="TwoEscalationcc" (change)="sentIntimationFormValid($event)">
                <label for="2Escalation">2nd Escalation</label>
              </div>
              <div class="md-checkbox">
                <input id="ResponsibleUser" type="checkbox" name="ResponsibleUser" [(ngModel)]="ResponsibleUser"
                  [disabled]="ResponsibleUsercc" (change)="sentIntimationFormValid($event)">
                <label for="ResponsibleUser">Responsible User</label>
              </div>
              <div class="md-checkbox">
                <input id="ResponsibleUser1" type="checkbox" name="ResponsibleUserone" [(ngModel)]="ResponsibleUserone"
                  [disabled]="ResponsibleUseronecc" (change)="sentIntimationFormValid($event)">
                <label for="ResponsibleUser1">Responsible User 1st Escalation</label>
              </div>
              <div class="md-checkbox">
                <input id="ResponsibleUser2" type="checkbox" name="ResponsibleUsertwo" [(ngModel)]="ResponsibleUsertwo"
                  [disabled]="ResponsibleUsertwocc" (change)="sentIntimationFormValid($event)">
                <label for="ResponsibleUser2">Responsible User 2nd Escalation</label>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <h5 class="font-weight-bold">Cc</h5>
              </div>
              <div class="md-checkbox">
                <input id="AssignedTocc" type="checkbox" name="AssignedTocc" [(ngModel)]="AssignedTocc"
                  [disabled]="ToAssignedTo">
                <label for="AssignedTocc">Assigned To </label>
              </div>
              <div class="md-checkbox">
                <input id="collegues" type="checkbox" name="Collegues" [(ngModel)]="Collegues">
                <label for="collegues">collegues</label>
              </div>
              <div class="md-checkbox">
                <input id="oneEscalationcc" type="checkbox" name="OneEscalationcc" [(ngModel)]="OneEscalationcc"
                  [disabled]="OneEscalation">
                <label for="oneEscalationcc">1st Escalation</label>
              </div>
              <div class="md-checkbox">
                <input id="twoEscalationcc" type="checkbox" name="TwoEscalationcc" [(ngModel)]="TwoEscalationcc"
                  [disabled]="TwoEscalation">
                <label for="twoEscalationcc">2nd Escalation</label>
              </div>
              <div class="md-checkbox">
                <input id="ResponsibleUsercc" type="checkbox" name="ResponsibleUsercc" [(ngModel)]="ResponsibleUsercc"
                  [disabled]="ResponsibleUser">
                <label for="ResponsibleUsercc">Responsible User</label>
              </div>
              <div class="md-checkbox">
                <input id="ResponsibleUseronecc" type="checkbox" name="ResponsibleUseronecc"
                  [(ngModel)]="ResponsibleUseronecc" [disabled]="ResponsibleUserone">
                <label for="ResponsibleUseronecc">Responsible User 1st Escalation</label>
              </div>
              <div class="md-checkbox">
                <input id="ResponsibleUsertwocc" type="checkbox" name="ResponsibleUsertwocc"
                  [(ngModel)]="ResponsibleUsertwocc" [disabled]="ResponsibleUsertwo">
                <label for="ResponsibleUsertwocc">Responsible User 2nd Escalation</label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button id="btnUploadProof" type="button" class="btn btn-sm btn-primary" name="IsSentIntimationFormValid"
            [disabled]="!IsSentIntimationFormValid" (click)="sendImmediateReminderMail()">
            <i class="fa fa-save"></i>Send</button>
          <button type="button" class="btn btn-sm" data-dismiss="modal" (click)="closeImmediateReminderMail()">
            <i class="fa fa-times"></i>Close</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="modal fade modal-size-large" id="uploadProofDialog1" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <em class="fa fa-upload"></em>
          <span id="uploadProofDialogTitle"></span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <em class="fa fa-times"></em>
        </button>
      </div>
      <div class="modal-body">
        <span class="cat__core__title">
          Existing Files
        </span>

        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="groupTable"
          class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
          <caption></caption>
          <thead>
            <tr>

              <th scope="head">Filename</th>
              <th scope="head">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let proof of taskProofData; let count=index">

              <td tabindex="1" style="cursor: move; width: 70%;">
                {{proof.DocName}}
              </td>
              <td>
                <button type="button" class="btn-sm btn btn-warning" (click)="downloadDoc(proof.DocumentManagementID)">
                  <span class="fa fa-download"></span>
                </button>
                <button type="button" class="btn-sm btn btn-danger"
                  (click)="deleteProofDoc(proof._id,proof.DocumentManagementID)">
                  <span class="fa fa-close"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label" for="l5">
              <span>Upload Proof
                <span _ngcontent-c2="" style="color: red;">*</span>
              </span>
            </label>
          </div>
          <div class="col-md-8">
            <div class="form-group">
              <input type="file" class='form-control fileUpload' (change)="proofChangeEvent($event)"
                accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx" multiple />
              <span *ngIf="typeHasError" style="color: red">
                Please upload valid file format.
              </span>

            </div>
          </div>
        </div>


      </div>
      <div class="modal-footer">

        <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary" (click)="uploadProofFile()">
          <em class="fa fa-save"></em>Upload</button>

        <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
          <em class="fa fa-times"></em>Close</button>

      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deletePdfConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="myModalLabelForDeletion">
          <em class="fa fa-question-circle-o mr-2"></em>Confirm
        </h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <em class="fa fa-times"></em>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            Are you sure you want to delete this proof document?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="removeDoc()" data-dismiss="modal">
          <em class="fa fa-check"></em>Yes</button>
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
          <em class="fa fa-times"></em>No</button>
      </div>
    </div>
  </div>
</div>